module.exports = __webpack_public_path__ + "static/media/m-manman.90910229.png";